import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Parser from "html-react-parser";
import { isEmpty, isUndefined } from "lodash";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import CardTypeFolder from "@components/CardTypeFolder/CardTypeFolder";
import Meta from "@components/Meta/Meta";
import useMediaQuery from "app/hooks/useMediaQuery";
import * as CMSActionsAhorro from "../../store/actions";

import "./Afiliacion.css";
const ROOT = process.env.REACT_APP_CMS_STATIC;
const BORDER_TOP_COLOR = "#d7de00";

const Afiliacion = () => {
  const dispatch = useDispatch();
  const [membership, setMembership] = useState({});
  const [detailTitleStyle, setDetailTitleStyle] = useState({
    minWidth: "225px",
    maxWidth: "75%",
    width: "fit-content",
  });

  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isIpadPortrait = useMediaQuery("(max-width: 992px)");
  const isIphoneLandscape = useMediaQuery("(max-width: 576px)");

  //Selectores de estado
  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { afiliacionCMS } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  const defRoute = rutas?.filter((route) => route?.name === "Afíliese");

  const getWidthTitle = () => {
    if (isIphoneLandscape) {
      setDetailTitleStyle({
        minWidth: "178",
        maxWidth: "100%",
        width: "fit-content",
      });
    } else if (isIpadPortrait || isIphoneLandscape) {
      setDetailTitleStyle({
        minWidth: "225px",
        maxWidth: "75%",
        width: "fit-content",
      });
    }
  };

  useEffect(() => {
    dispatch(CMSActionsAhorro.getCMSAfiliacion());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getWidthTitle();
    if (!isEmpty(afiliacionCMS)) {
      let btnForm;
      if (!isEmpty(afiliacionCMS.afiliacion[0].uRLFormularioAfiliacion.url)) {
        if (
          isIphoneLandscape &&
          !isUndefined(afiliacionCMS.afiliacion[0].botonAfiliacionMovil.urls[0])
        ) {
          btnForm = {
            url: afiliacionCMS.afiliacion[0].uRLFormularioAfiliacion.url,
            img:
              ROOT + afiliacionCMS.afiliacion[0].botonAfiliacionMovil.urls[0],
            alt: afiliacionCMS.afiliacion[0].uRLFormularioAfiliacion.text,
          };
        } else if (
          isIpadPortrait &&
          !isUndefined(afiliacionCMS.afiliacion[0].botonAfiliacionIpad.urls[0])
        ) {
          btnForm = {
            url: afiliacionCMS.afiliacion[0].uRLFormularioAfiliacion.url,
            img: ROOT + afiliacionCMS.afiliacion[0].botonAfiliacionIpad.urls[0],
            alt: afiliacionCMS.afiliacion[0].uRLFormularioAfiliacion.text,
          };
        } else if (
          isDesktop &&
          !isUndefined(afiliacionCMS.afiliacion[0].botonAfiliacion.urls[0])
        ) {
          btnForm = {
            url: afiliacionCMS.afiliacion[0].uRLFormularioAfiliacion.url,
            img: ROOT + afiliacionCMS.afiliacion[0].botonAfiliacion.urls[0],
            alt: afiliacionCMS.afiliacion[0].uRLFormularioAfiliacion.text,
          };
        }
      }

      setMembership({
        title: afiliacionCMS.afiliacion[0].titulo,
        description: afiliacionCMS.afiliacion[0].descripcion.html,
        details: afiliacionCMS.afiliacion[0].detalles.contentItems.map(
          (detail) => {
            return {
              title: detail.title,
              description: detail.description.html,
            };
          }
        ),
        files: afiliacionCMS.afiliacion[0].archivosDescargables?.contentItems
          ? afiliacionCMS.afiliacion[0].archivosDescargables?.contentItems.map(
              (file) => {
                return {
                  fileName: file.tituloEnlace,
                  fileURL: ROOT + file.archivo.urls[0],
                };
              }
            )
          : [],
        buttons: btnForm ? [btnForm] : [],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [afiliacionCMS, isIphoneLandscape, isIpadPortrait, isDesktop]);

  const buttons = (
    <div className="w-100">
      {membership.buttons &&
        membership.buttons.length > 0 &&
        membership.buttons.map((button) => (
          <div className="button-container">
            <div className="cmsButton">
              <a
                className="anchor"
                href={button.url}
                target="_blank"
                rel="noreferrer"
              >
                <img className="img" src={button.img} alt={button.alt} />
              </a>
            </div>
          </div>
        ))}
    </div>
  );

  return (
    <>
      <Meta
        title={defRoute[0]?.title}
        description={defRoute[0]?.description}
        canonicalUrl={defRoute[0]?.url}
      />
      <Breadcrumbs items={[]} active={defRoute[0]?.name} />
      <div className="membership-container">
        <div className="w-100 d-flex flex-column align-items-start text-left">
          <h1 className="membership-title">{membership.title}</h1>
          <span className="membership-description">
            {membership.description && Parser(membership.description)}
          </span>
        </div>
        <div className="w-100">
          {membership.details &&
            membership.details.map((detail, index) => (
              <CardTypeFolder
                key={index}
                titleStyle={detailTitleStyle}
                title={detail.title}
                description={detail.description}
                borderTopColor={BORDER_TOP_COLOR}
              />
            ))}
          {membership.files && membership.files.length > 0 && (
            <CardTypeFolder
              titleStyle={detailTitleStyle}
              title="Documentos"
              description=""
              files={membership.files}
              borderTopColor={BORDER_TOP_COLOR}
            />
          )}
        </div>
        {buttons}
      </div>
    </>
  );
};

export default Afiliacion;
